import React from "react";
import LogoutSuccessAlert from "../components/auth/LogoutSuccessAlert";

interface LogoutPageProps {
  [key: string]: any;
}

function LogoutPage(props: LogoutPageProps) {
  return (
    <div className="flex items-center justify-center min-h-screen bg-white">
      <div className="flex w-[374px] flex-col items-center gap-[36px] flex-shrink-0">
        <img
          src="/assets/images/kimaru.png"
          alt="kimaru.ai logo"
          className="w-[232px] h-[63px]"
        />
        <LogoutSuccessAlert />
        <form className="flex flex-col w-full items-start gap-[24px] p-[24px] rounded-lg border border-[#E4E4E7] bg-white shadow-md">
          <h2 className="text-[#09090B] font-sans text-2xl font-semibold leading-8 w-full">
            Login
          </h2>
          <p className="text-[#64748B] font-sans text-sm font-normal leading-5 w-full">
            Enter your email and password to log in to your account.
          </p>
          <div className="flex flex-col w-full gap-[8px]">
            <label
              htmlFor="email"
              className="text-[#111827] font-sans text-sm font-medium w-full"
            >
              Email
            </label>
            <input
              type="email"
              id="email"
              placeholder="Placeholder"
              className="h-10 px-3 py-2 w-full rounded-md border border-[#E2E8F0] bg-white text-sm"
            />
          </div>
          <div className="flex flex-col w-full gap-[8px]">
            <label
              htmlFor="password"
              className="text-[#111827] font-sans text-sm font-medium w-full"
            >
              Password
            </label>
            <input
              type="password"
              id="password"
              placeholder="Placeholder"
              className="h-10 px-3 py-2 w-full rounded-md border border-[#E2E8F0] bg-white text-sm"
            />
          </div>
          <button
            type="submit"
            className="flex h-10 w-full items-center justify-center gap-2 rounded-md bg-[#0F172A] text-white font-semibold text-sm"
          >
            Sign in
          </button>
        </form>
      </div>
    </div>
  );
}

export default LogoutPage;
